import React, { useEffect } from 'react';

// Hooks
import { useSubscriptionTracking } from 'Shared/tracking/use-subscription-tracking';
import { useApp } from 'Shared/utils/hooks/use-app';

// Types
import { Feature } from 'Shared/types/Organization.type';
import { Illustrations } from 'Wpds/components/illustration';

// Components
import { WpButton } from 'Wpds/components/button';
import EmptyStateContainer from 'Shared/components/EmptyStateContainer/EmptyStateContainer';

import './PerformanceReviewFreePlanContent.scss';

const PerformanceReviewFreePlanContent = () => {
  const { intercomTOEPerformanceReviewsEventName } = useApp();
  const { trackViewedFeatureGate } = useSubscriptionTracking();

  useEffect(() => {
    trackViewedFeatureGate({ feature: Feature.performanceReviews });
  }, []);

  const baseClassName = 'PerformanceReviewFreePlanContent';

  return (
    <div className={baseClassName}>
      <EmptyStateContainer
        title="Review cycles that truly lead to better performance"
        subTitle="Use behavioral insights to produce more impactful development discussions, foster stronger engagement, identify clearer paths to growth, and ensure every employee feels understood and supported."
        button={
          <WpButton dataAttributes={{ 'data-intercom': intercomTOEPerformanceReviewsEventName }}>
            Get Perform Reviews
          </WpButton>
        }
        image={Illustrations.two_people_standing_with_laptop_purple_bg}
      />
    </div>
  );
};

export default PerformanceReviewFreePlanContent;
